import {
    BokSettingsGetResponse,
    IWatchedItem,
    IWatcher,
    Ulid,
} from "@kase/my-marathon-communication";
import { signal } from "@preact/signals";
import { ApiSliceParams } from "../interfaces";

const DEFAULT_BOOK_SETTINGS = {
    _id: Ulid.ZERO,
    id: Ulid.ZERO.toString(),
    registration: {
        purchase_code_in_expense: true,
        vat_mandatory_expense: true,
    },
    vat: {
        automatic_posting_vat: false,
        vat_on_project_purchases: true,
    },
};

export const makeBook = ({ connection, company }: ApiSliceParams) => {
    const loading = signal(false);
    const loaded = signal(false);
    const store = signal(DEFAULT_BOOK_SETTINGS);
    let watcher: IWatcher<IWatchedItem<Ulid, BokSettingsGetResponse>> | null =
        null;

    const listen = () => {
        if (watcher) {
            return;
        }

        loading.value = true;

        watcher = connection.value.boksettings.get({ company: company.value });

        connection.value.boksettings.get({ company: company.value });

        watcher.listen((value) => {
            const result = value.item;

            if (result) {
                const newValue = {
                    id: result.id.toString(),
                    _id: result.id,
                    registration: {
                        purchase_code_in_expense:
                            result.registration?.purchase_code_in_expense ??
                            true,
                        vat_mandatory_expense:
                            result.registration?.vat_mandatory_expense ?? true,
                    },
                    vat: {
                        automatic_posting_vat:
                            result.vat?.automatic_posting_vat ?? false,
                        vat_on_project_purchases:
                            result.vat?.vat_on_project_purchases ?? true,
                    },
                };

                store.value = newValue;
            } else {
                store.value = DEFAULT_BOOK_SETTINGS;
            }

            if (!loaded.peek()) {
                loaded.value = true;
                loading.value = false;
            }

            return true;
        });
    };

    return {
        store,
        listen,
    };
};
